var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_328_368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C10.0898 13 13 10.0898 13 6.5C13 2.91015 10.0898 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0898 2.91015 13 6.5 13Z",
    fill: "#00BA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47001 9.67006L2.09275 7.12569C1.76729 6.77735 1.78597 6.22623 2.13431 5.90077C2.48265 5.57531 3.03377 5.59405 3.35923 5.94233L5.19295 7.90492L8.09548 5.19299C8.12158 5.16858 8.14886 5.14621 8.17706 5.12564L9.54201 3.85036C9.89035 3.5249 10.4415 3.54363 10.7669 3.89197C11.0924 4.24025 11.0737 4.79142 10.7254 5.11688L6.55646 9.01202L6.55201 9.00726L5.10993 10.3547L4.47001 9.67006Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_328_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.29665650b5c8eef8e89a2f5211d625b1.svg";
export { ForwardRef as ReactComponent };